import { AuthUserPermission, Can, usePermissions } from '@cibo/profile'
import { Button, ButtonProps, Menu, MenuItem } from '@mui/material'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { LandManagementContext, useGenerateTestField } from '../../..'

export interface AddFieldsButtonProps extends ButtonProps {
  paths?: {
    draw: string
    upload: string
  }
  buttonText?: string
}

export const AddFieldsButton = ({ buttonText, paths, ...props }: AddFieldsButtonProps) => {
  const { t } = useTranslation('@cibo/landmanager/AddFieldsButton')
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const { can } = usePermissions()
  const { LAND_MANAGER_ROUTES, openImportFieldAlyticsDialog } = useContext(LandManagementContext)
  const { generateTestField } = useGenerateTestField()

  return (
    <>
      <Button
        {...props}
        onClick={e => setAnchorEl(e.currentTarget)}
        data-testid="add-land-menu"
        disabled={
          !can({ useAny: AuthUserPermission.FIELD_CREATE }) &&
          !can({ useAny: AuthUserPermission.UPLOAD_SHAPEFILES })
        }
      >
        {buttonText || t('addLand')}
      </Button>
      <Menu anchorEl={anchorEl} onClose={() => setAnchorEl(null)} open={open}>
        <MenuItem
          onClick={() => navigate(paths?.upload ? paths.upload : LAND_MANAGER_ROUTES.UPLOAD)}
          data-testid="upload-land-menu-item"
          disabled={!can({ useAny: AuthUserPermission.UPLOAD_SHAPEFILES })}
        >
          {t('uploadShapefile')}
        </MenuItem>
        <MenuItem
          onClick={() => navigate(paths?.draw ? paths.draw : LAND_MANAGER_ROUTES.DRAW)}
          data-testid="draw-field-menu-item"
          disabled={!can({ useAny: AuthUserPermission.FIELD_CREATE })}
        >
          {t('drawField')}
        </MenuItem>
        <Can useAny={AuthUserPermission.DEBUG_USER}>
          <MenuItem
            onClick={() => generateTestField([], { labels: ['random test'] })}
            data-testid="test-field-menu-item"
          >
            {t('randomTestField')}
          </MenuItem>
        </Can>

        <Can useAny={AuthUserPermission.FIELDALYTICS_IMPORT_REQUEST}>
          <MenuItem
            onClick={() => {
              openImportFieldAlyticsDialog()
              setAnchorEl(null)
            }}
            data-testid="import-fieldalytics-menu-item"
          >
            {t('importFieldAlytics')}
          </MenuItem>
        </Can>
      </Menu>
    </>
  )
}
